module.exports = __webpack_public_path__ + "media/images/social/max-a-52e181392e26e6b7dd38b26de5c047a2.svg";